import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-plus-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [style.color]="color()"
      [class]="iconClass()"
      fill="none">
      <path
        d="M8 3.5V12.5"
        stroke="currentColor"
        [attr.stroke-width]="strokeWidth()"
        stroke-linecap="round" />
      <path
        d="M3.5 8H12.5"
        stroke="currentColor"
        [attr.stroke-width]="strokeWidth()"
        stroke-linecap="round" />
    </svg>
  `,
})
export class PlusIconComponent extends BaseIconComponent {
  override readonly width = input<string>('16');
  override readonly height = input<string>('16');
  override readonly viewBox = input<string>('0 0 16 16');
  readonly strokeWidth = input<string>('1.5');
}
